import React from "react";
import { RouteObject } from "react-router";

export const UserRoutes: RouteObject[] = [
  {
    path: "",
    async loader(args) {
      const { usersTabLoader } = await import(
        /* webpackChunkName: "orgs-cache-users-tab-loader" */ "src/router/loaders/orgs/Users"
      );
      return usersTabLoader(args);
    },
    async lazy() {
      const { UsersTab } = await import(/* webpackChunkName: "orgs-cache-users-tab" */ "orgs/Configuration/UsersTab");
      return { element: <UsersTab /> };
    },
    children: [
      {
        path: "commission/:userId",
        async loader(args) {
          const { userCommissionLoader } = await import(
            /* webpackChunkName: "orgs-cache-user-commission-loader" */ "src/router/loaders/orgs/Users"
          );
          return userCommissionLoader(args);
        },
        async lazy() {
          const { CommissionValuesModal } = await import(
            /* webpackChunkName: "orgs-cache-commission-values-modal" */ "orgs/Configuration/UsersTab/CommissionValuesModal"
          );
          return { element: <CommissionValuesModal /> };
        },
      },
      {
        path: "sample_jobs/:userId",
        async loader(args) {
          const { sampleJobsLoader } = await import(
            /* webpackChunkName: "orgs-cache-sample-jobs-loader" */ "src/router/loaders/orgs/Users"
          );
          return sampleJobsLoader(args);
        },
        async lazy() {
          const { SampleJobsModal } = await import(
            /* webpackChunkName: "orgs-cache-sample-jobs-modal" */ "orgs/Configuration/UsersTab/SampleJobsModal"
          );
          return { element: <SampleJobsModal /> };
        },
      },
    ],
  },
  {
    path: "add",
    async loader(args) {
      const { userAddLoader } = await import(
        /* webpackChunkName: "orgs-cache-user-add-loader" */ "src/router/loaders/orgs/Users"
      );
      return userAddLoader(args);
    },
    async lazy() {
      const { EditUser } = await import(
        /* webpackChunkName: "orgs-cache-edit-user" */ "orgs/Configuration/UsersTab/EditUser"
      );
      return { element: <EditUser /> };
    },
  },
  {
    path: ":userId",
    async loader(args) {
      const { userLoader } = await import(
        /* webpackChunkName: "orgs-cache-user-loader" */ "src/router/loaders/orgs/Users"
      );
      return userLoader(args);
    },
    shouldRevalidate: () => false,
    children: [
      {
        path: "edit",
        async loader(args) {
          const { userEditLoader } = await import(
            /* webpackChunkName: "orgs-cache-user-edit-loader" */ "src/router/loaders/orgs/Users"
          );
          return userEditLoader(args);
        },
        async lazy() {
          const { EditUser } = await import(
            /* webpackChunkName: "orgs-cache-edit-user-modal" */ "orgs/Configuration/UsersTab/EditUser"
          );
          return { element: <EditUser /> };
        },
      },
    ],
  },
];
